import { render, staticRenderFns } from "./mainindex.vue?vue&type=template&id=42035d65"
import script from "./mainindex.vue?vue&type=script&lang=js"
export * from "./mainindex.vue?vue&type=script&lang=js"
import style0 from "./mainindex.vue?vue&type=style&index=0&id=42035d65&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports